/*
 * @Author: Ryan
 * @Date: 2026-02-04
 * @Description: SEO sections entry file for AI TikTok Video Generator page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import FeaturesSection from './FeaturesSection';
import HeroSection from './HeroSection';
import HeroSupportingSection from './HeroSupportingSection';
import HowToUseSection from './HowToUseSection';
import TestimonialsSection from './TestimonialsSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <HeroSection />
      <HeroSupportingSection />
      <HowToUseSection />
      <FeaturesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;
